import getSteelMakerName from '../../getSteelMakerName';
import type { Language, ProcessCellCallbackParams, SelectOption, SteelMaker } from '../../../types/common';
import type { OptionsType } from '../../../types/options';

const steelMakerCellCallback = (params: ProcessCellCallbackParams): string => {
  const value: SteelMaker | SteelMaker[] = params.value;
  const steelMakerCodes: SteelMaker[] = Array.isArray(value) ? value : [value];
  const currentLang: SelectOption<Language> | undefined = params.context?.currentLang;
  const steelMaker: OptionsType<SteelMaker>[] | undefined = params.context?.steelMaker;
  // 鉄鋼メーカーコードの配列を鉄鋼メーカー名の配列にマップする。マッチするものが見つからなかったらコードのままにする。
  const steelMakerNames: string[] = steelMakerCodes.map((code) => {
    const steelMakerName: string = getSteelMakerName(code, steelMaker, currentLang.value);
    return steelMakerName;
  });
  const filterValue: string = steelMakerNames.join(', ');
  return filterValue;
};

export default steelMakerCellCallback;
